<template>
    <div id="construcao" class="construcao-page">
        <Menu-component />
        <div class="container">
        <section class="background">
            <div class="content-wrapper">
                <div class="title-section">
                    <h2>A Construção</h2>
                </div>
                <div class="content">
                    <div class="content-box-01">
                        <h3>O processo de construção</h3>
                        <img src="@/assets/info-01.png" alt="Imagem gráfico de construção">
                    </div>
                    <div class="content-box-02">
                        <p>A metodologia do ISH foi desenvolvida com dados de diversos estudos preexistentes da ANA e órgãos afins e aplicada em escala com alto grau de detalhamento. Paralelamente, foi realizado um amplo inventário de Estudos, Planos, Projetos e Obras (EPPOs) existentes e em diferentes fases de planejamento e implantação. </p>
                        <p>A partir do ISH, foram delineadas Unidades Territoriais de Análise (UTAs) que concentram os maiores valores em risco dos indicadores das dimensões humana e econômica. Nessas unidades, foi realizada uma análise integrada para identificar as intervenções que se configuram como soluções estratégicas e atendem aos requisitos do PNSH. Metodologia similar foi adotada no controle de cheias. As intervenções selecionadas, em diferentes estágios de desenvolvimento (estudos, planos, projetos e obras), consolidam o Programa de Segurança Hídrica (PSH).</p>
                    </div>
                </div>
                <div class="navegacao">
                    <div class="arrow-down" @click="next">
                        <img src="@/assets/arrow-down.svg" />
                    </div>
                </div>
            </div>
        </section>
        <section class="background">
            <div class="content-wrapper">
                <div class="section-2">
                    <div class="content">
                        <div class="content-box-01">
                            <p>A Análise Integrada foi o ponto central da construção do PNSH ao confrontar o diagnóstico do problema de segurança hídrica com as propostas de solução. A análise realizada nas UTAs considerou três abordagens – qualitativa, quantitativa e complementar – para cotejamento das intervenções inventariadas (EPPOs) com o ISH em cada uma das suas dimensões. O resultado da análise integrada foi o encaminhamento das intervenções selecionadas para o Programa de Segurança Hídrica (PSH), que reúne os investimentos estratégicos recomendados pelo PNSH em três grandes componentes: <br><br><br>                             1) Estudos e Projetos, 2) Obras e 3) Institucional. </p>
                        </div>
                        <div class="content-box-02">
                            <h3>Análise integrada</h3>
                            <img src="@/assets/info-02.png" alt="Infográfico Intervencoes e Encaminhamento ao PSH">
                        </div>
                    </div>
                    <router-link tag="button" class="btn-green" to="programa">O Programa</router-link>
                </div>
                <div class="navegacao-02">
                <div class="arrow-up" @click="prev">
                            <img src="@/assets/arrow-up.svg" />
                </div>
            </div>
            </div>
        </section>
        </div>
    </div>

</template>

<script>
import Menu from '@/components/Menu'



export default {

  components: {
    'Menu-component': Menu
  },


  data () {
    return {
      eventoScroll: null,
      delta: null,
      ticking: false,
      scrollSensitivitySetting: 30,
      currentSlideNumber: 0,
      totalSlideNumber: null,
      slideDurationSetting: 600
    }
  },

  mounted () {
    this.totalSlideNumber = document.querySelectorAll('.background').length;
    this.previousItem()
    this.mousewhellevent();
  },

   destroyed () {
      window.removeEventListener('wheel', this.onMouseWheel);
   },

  methods: {

    mousewhellevent () {
      let screen = window.screen.width
      if (screen <= 1200) {
        return false
      }

       window.addEventListener('wheel', this.onMouseWheel);
    },

    onMouseWheel (evt) {
        this.eventoScroll = evt
        this.parallaxScroll(this.eventoScroll)
    },

    parallaxScroll (evt) {
      let isFirefox = (/Firefox/i.test(navigator.userAgent));
      let isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));

      if (isFirefox) {
        this.delta = evt.detail * (-120);
      } else if (isIe) {
        this.delta = -evt.deltaY;
      } else {
        this.delta = evt.wheelDelta;
      }

      if (this.ticking !== true) {
        if (this.delta <= -this.scrollSensitivitySetting) {
          this.ticking = true;

          if (this.currentSlideNumber !== this.totalSlideNumber - 1) {
            this.currentSlideNumber++;
            this.nextItem();
          }
          this.slideDurationTimeout(this.slideDurationSetting);
        }
        if (this.delta >= this.scrollSensitivitySetting) {
          this.ticking = true;
          if (this.currentSlideNumber !== 0) {
            this.currentSlideNumber--;
          }
          this.previousItem();
          this.slideDurationTimeout(this.slideDurationSetting);
        }
      }
    },

    nextItem () {
       var $previousSlide = document.querySelectorAll('.background')[this.currentSlideNumber - 1];
       $previousSlide.classList.remove('up-scroll')
       $previousSlide.classList.add('down-scroll');
    },

    next () {
        this.currentSlideNumber++;
        this.nextItem()
    },

    prev () {
        this.currentSlideNumber--;
        this.previousItem()
    },

    previousItem () {
      var $currentSlide = document.querySelectorAll('.background')[this.currentSlideNumber];
      $currentSlide.classList.remove('down-scroll')
      $currentSlide.classList.add('up-scroll');
    },

    slideDurationTimeout (slideDuration) {
      setTimeout(() => {
        this.ticking = false;
      }, slideDuration);
    }
  }
};
</script>


<style lang="scss" scoped>

.container {
    padding-top: 70px;
    width: 1234px;
    @include media_tablet() {
        padding-top: 50px;
        width: 100%;
    }
}


.construcao-page {
    position: relative;
    &::after {
        content: '';
        background-image: url(../assets/assets-esquerda.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0px;
        height: 60vh;
        width: 10vh;
        @include media_tablet() {
          display: none;
        }
    }

    &::before {
        content: '';
        background-image: url(../assets/assets-direita.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 189px;
        right: 0px;
        height: 995px;
        width: 21vh;
        @include media_tablet() {
          display: none;
        }
    }
}

#construcao {
  .content-wrapper {
    h3 {
      padding-left: 209px;
      margin-bottom: 26px;

      @include media_tablet() {
        padding-left: 0;
      }
      @media (max-height:  900px) and (min-width: 1200px) {
        padding-left: 192px;
        margin-bottom: 26px;
      }
    }

    .content {
      display: flex;
      background-color: #ffffff;

      @include media_tablet() {
        padding: 0 22px;
        flex-direction: column;
      }

      @media (max-height:  900px) and (min-width: 1200px)   {
        justify-content: center;
      }

      .content-box-01 {
        width: 821px;

        @include media_tablet() {
          width: 100%;
        }

        @media (max-height:  900px) and (min-width: 1200px) {
            width: 30%;
        }
        img {
          max-width: 100%;
        }
      }
      .content-box-02 {
        background-color: #ffffff;
        padding-left: 25px;
        width: 420px;

        @include media_tablet() {
          margin-top: 26px;
          padding: 0px;
          width: 100%;
        }

        @media (max-height:  900px) and (min-width: 1200px) {
            width: 50%;
        }

        p {
          padding-left: 25px;
          line-height: 24px;

        @media (max-height:  900px) and (min-width: 1200px) {
            padding-left: 25px;
            line-height: 22px;
            font-size: 13px;
        }

          @include media_tablet() {
            padding: 0px;
          }

          &:nth-child(1) {
            margin-bottom: 30px;
            @media (max-height:  900px) and (min-width: 1200px) {
                margin-bottom: 16px;
                font-size: 13px;
            }
          }
        }
      }
    }

.section-2 {
  .content {
    display: flex;

    @include media_tablet() {
      flex-direction: column;
    }


    .content-box-01 {
        padding-top: 60px;
        padding-left: 120px;
        padding-right: 29px;
        width: 516px;

        @include media_tablet() {
            width: 100%;
            padding: 0;
            margin-top: 35px;
        }

        @media (max-height:  900px) and (min-width: 1200px)   {
            padding-top: 10px;
            padding-left: 0px;
            padding-right: 29px;
            width: 40%;
        }

        p {
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 10px;
          @media (max-height:  900px) and (min-width: 1200px)   {
            font-size: 13px;
            line-height: 23px;
            margin-bottom: 0px;
          }
        }

        ul {
          p {
            margin-bottom: 5px;
          }
        }
      }
      .content-box-02 {
        width: 719px;

        @include media_tablet() {
          width: 100%;
        }

        @media (max-height:  900px) and (min-width: 1200px)   {
            width: 30%;
        }

        h3 {
          text-align: left;
          padding: 0px;
          @include media_tablet() {
            padding: 0 22px;
            margin: 21px 0;
          }
        }
        img {
          max-width: 100%;
          @include media_tablet() {
            padding: 0 22px;
          }
          @media (max-height:  900px) and (min-width: 1200px)   {
            max-width: 80%;
          }
        }

      }
}
    button {
          cursor: pointer;
          margin: 67px 0 0 auto;
          &::after {
            content: "";
            position: absolute;
            right: 70px;
            top: 17px;
            background-repeat: no-repeat;
            background-image: url(../assets/seta-direita-branca.svg);
            width: 9px;
            height: 14px;

            @include media_tablet() {
              top: 22px;
              right: 35px;
            }
          }

          @include media_tablet() {
            margin: 15px 0 0 0;
            width: 100%;
            border-radius: 30px 30px 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @media (max-height:  900px) and (min-width: 1200px)   {
                cursor: pointer;
                margin: 67px 0 0 auto;
                position: absolute;
                right: 20vw;
          }
        }
  }
  }
}



.navegacao {
    position: absolute;
    bottom: 22vh;
}
.navegacao-02 {
    position: absolute;
    bottom: 22vh;
}
</style>
